import { render, staticRenderFns } from "./HistorySecadero.vue?vue&type=template&id=7a829077&scoped=true&lang=es"
import script from "./HistorySecadero.vue?vue&type=script&lang=js"
export * from "./HistorySecadero.vue?vue&type=script&lang=js"
import style0 from "./HistorySecadero.vue?vue&type=style&index=0&id=7a829077&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a829077",
  null
  
)

export default component.exports